import React from 'react';
import UserCircleIcon from '@heroicons/react/outline/UserCircleIcon.js';
import { BlockType } from '../../types/index.js';
import { AuthMemberCardBlock as Component } from './Block.js';
export const RegisteredAuthMemberCardBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'AuthMemberCard',
        Component,
        config: {
            type: BlockType.Block,
            usable: true,
            displayName: $t({
                id: 'Blocks.AuthMemberCard.DisplayName',
                defaultMessage: 'Auth Member Card',
            }),
            Icon: React.createElement(UserCircleIcon, null),
        },
    };
};
//# sourceMappingURL=registered.js.map